<!--eslint-disable vue/no-mutating-props-->
<template>
  <fl-input v-if="type=='audio' || type=='tts'" type="textarea" v-model="message_params.text" :label="type=='tts'?'Фраза':'Транскрибация'"/>
  <fl-input v-if="type=='tts'" type="checkbox" v-model="message_params.ssml" label="SSML"/>
</template>

<script>
import FlInput from "../components/FlInput";

export default {
  components: {FlInput},
  props: ["type", "message_params", "audio_settings", "script"],
}
</script>
